import React from "react";
import { connect, shallowEqual } from "react-redux";
import { d3 } from "../../adapter";
import WeatherDataBrushChart from "./../../charts/weatherDataBrushChart";

class WeatherDataBrush extends React.Component {
  constructor(props) {
    super(props);
    this.chartRef = React.createRef();
    this.chart = undefined;
  }

  componentDidMount() {
    var el = this.chartRef.current;
    this.chart = new WeatherDataBrushChart(
      {
        id: "chart-weather-data-brush",
        height: 150,
        class: "chart weather-data brush",
        width: parseInt(d3.select(el).style("width"), 10), // With of the container element
      },
      this.getChartState(this.props),
      this.props.dispatch
    );

    this.chart.init(el);

    window.addEventListener("resize", () => {
      this.handleResize();
    });
  }

  handleResize() {
    var el = this.chartRef.current;
    if (el) this.chart.resize(parseInt(d3.select(el).style("width"), 10), false);
  }

  shouldComponentUpdate(nextProps) {
    // Only update the chart when the props are not equal
    if (
      !shallowEqual(this.props.domain, nextProps.domain) ||
      !shallowEqual(this.props.station, nextProps.station)
    ) {
      this.chart.update(this.getChartState(nextProps));
    }

    // Change hovered state
    if (this.props.hovered !== nextProps.hovered || this.props.pinned !== nextProps.pinned) {
      this.chart.updateHoverState(nextProps.hovered, nextProps.pinned, nextProps.pinDate);
    }

    return false;
  }

  getChartState(props) {
    return {
      station: props.station,
      domain: props.domain,
      hoverDate: props.hoverDate,
      pinDate: props.pinDate,
      pinned: props.pinned,
      fetchPeriod: props.fetchPeriod,
    };
  }

  componentWillUnmount() {
    this.chart.destroy();
  }

  render() {
    return <div ref={this.chartRef} />;
  }
}

const mapStateToProps = (state) => ({ ...state.weatherStationAnalysis });

export default connect(mapStateToProps)(WeatherDataBrush);
